import { API } from '@/shared/api/modules';
import type { GetFacilityFloorPlanRequestDto } from '@/shared/api/modules/floor-plan';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const getFacilityFloorPlanQueryOptions = (
  params: GetFacilityFloorPlanRequestDto
) =>
  queryOptions({
    queryKey: ['facility-floor-plan', params],
    queryFn: () => API.floorPlan.getFacilityFloorPlan(params),
    placeholderData: keepPreviousData,
  });
